import type { FC } from 'react';
import { ListItem, SkeletonLine } from '@george-labs.com/design-system';

import { getRandomNumber } from '../ProductSkeletonService';

const MIN_WIDTH = 40;
const MAX_CONTENT_WIDTH = 60;

interface Props {
    'data-cy'?: string;
}

export const AddressItemSkeleton: FC<Props> = ({ 'data-cy': dataCy }) => (
    <ListItem className="py-0" data-cy={dataCy}>
        <SkeletonLine
            animated
            level={4}
            percentageWidth={getRandomNumber(MIN_WIDTH, MAX_CONTENT_WIDTH)}
            className="py-0"
        />
    </ListItem>
);
